import { deepCopy } from './deepCopy';
import { isObject } from './isObject';

type ConfigObject = Record<string, unknown>;

/**
 * Deep merges target into source, applying changes from target to source.
 * - For nested objects, recursively merges
 * - For arrays and primitives, target value replaces source
 *
 * Example:
 *   source: { a: 1, b: { c: 2, d: 3 } }
 *   target: { b: { c: 5 }, e: 6 }
 *   result: { a: 1, b: { c: 5, d: 3 }, e: 6 }
 */
export function deepMerge(source: ConfigObject, target: ConfigObject): ConfigObject {
  const result = deepCopy(source);

  Object.keys(target).forEach((key) => {
    const targetValue = target[key];
    const sourceValue = source[key];

    if (isObject(targetValue) && isObject(sourceValue) && !Array.isArray(targetValue) && !Array.isArray(sourceValue)) {
      // Both are objects - recurse
      result[key] = deepMerge(sourceValue as ConfigObject, targetValue as ConfigObject);
    } else {
      // Replace with target value (including null)
      result[key] = targetValue;
    }
  });

  return result;
}
